module.exports = __webpack_public_path__ + "img/28.7a8c42df.jpg";